import { Link } from "react-router-dom";
import { PropsWithChildren } from "react";

const ConditionalLink = ({
  condition,
  to,
  children,
  ...rest
}: PropsWithChildren<{
  condition?: boolean;
  to?: string;
  className?: string;
}>) => {
  return condition === true || (condition === undefined && to) ? (
    <Link to={to || ""} {...rest}>
      {children}
    </Link>
  ) : (
    children
  );
};

export default ConditionalLink;
